@if (gameIframe.source) {
  <div
    [ngClass]="{'pip': gameIframe.isPip, 'full-screen': fullScreen.isFullScreen}"
    [style.height.px]="gameIframe.iframeHeight"
    class="game-screen"
    >
    @if (gameIframe?.source) {
      <div class="game">
        <iframe class="game__iframe" [src]="gameIframe?.source"></iframe>
        @if (gameIframe.isPip) {
          <div class="game__actions">
            @if (gameIframe.game) {
              <p class="game__actions_name">{{ gameIframe.game?.name }}</p>
            }
            <div class="game__actions_row">
              <i class="nav__item icon-picture-in-picture" (click)="gameIframe.togglePipGame(false)"></i>
              <i class="nav__item icon-close" (click)="gameIframe.closeGame();"></i>
            </div>
          </div>
        }
      </div>
    }
  </div>
}



